import { Component, OnInit, Input, ViewChild, ElementRef, EventEmitter, Output, ViewEncapsulation } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { Transaction, Payment } from '../../models';
import { PrintServicesService } from '../../services/print-services.service';
import { TokenServiceService } from '../../services/token-service.service';
import { DepositsManageService } from 'src/app/services/deposits-manage.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertService } from '../../services/alert.service';
import { EmailValidator } from '../../tools/email-validator';
import { ALERT_BUTTONS_MESSAGES, ALERT_MESSAGES } from '../../core/constants/AlertMessages';
import { AVAILABLE_TRANSLATIONS, CURRENCIES } from '../../../assets/strings/translations';
import { AUTOCOMPLETE_METHOD_PAY_TYPES, FLAGS_NAME, GENERAL_CONSTANTS } from 'src/app/core/constants/General-constants';
import { BANK_GU_IDS } from 'src/app/core/constants/payMethods-gu';
import { ALERT_ERRORS } from 'src/app/core/constants/Errors';
import { PatchValAdditionalInfoService } from 'src/app/services/patch-val-additional-info.service';
import { PayvalidaFeatureFlagService } from 'src/app/services/payvalida-feature-flag.service';
import { BANK_IDS } from 'src/app/core/constants/payMethods-cr';

@Component({
    selector: 'app-deposit',
    templateUrl: './deposit.component.html',
    styleUrls: ['./deposit.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class DepositComponent implements OnInit {
    @Input() info: Payment;
    @Input() currentConcept: any;
    @Input() flagActive: boolean;

    user;
    loading: boolean;
    transaction: Transaction;
    orderID: string;
    template: string;
    showSpecial: boolean;
    attemps = 0;
    viewReference = false;

    currentCountry: string = AVAILABLE_TRANSLATIONS.COL;
    errorCodes = GENERAL_CONSTANTS.RESPONSE_GENERAL_ERROR_CODES;

    @ViewChild('printCash') elem: ElementRef;
    @Output() CASH = new EventEmitter();
    @Output() buttonStateChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    emailForm: FormGroup;
    isBamPaymethod: boolean;
    isBiAgencyPaymethod: boolean;
    isBiAgentPaymethod: boolean;
    isSuper24PayMethod: boolean;
    isBancoNacionalDepositPayMethod: boolean;
    formPrivacyValid: boolean = false;
    buttonEnabled: boolean = false;
    transferAndDepositsAutoCompleteFF: boolean = false;
    isEditableInfo: boolean = false;
    objectControlData = [
      {
          formControl: 'email',
          readOnly: false,
      },
    ];

    constructor(
        private readonly authService: AuthService,
        private readonly alertService: AlertService,
        private readonly printServicesService: PrintServicesService,
        private readonly tokenServiceService: TokenServiceService,
        private readonly depositManager: DepositsManageService,
        private readonly formBuilder: FormBuilder,
        private patchValAdditionalInfoService: PatchValAdditionalInfoService,
        private featureFlagService: PayvalidaFeatureFlagService,
    ) {
        this.emailForm = this.formBuilder.group({
            email: ['', Validators.compose([Validators.required, EmailValidator.isValid])],
        });
    }

    ngOnInit() {
        this.onActivate();

        this.orderID = this.authService.getOrderID();
        this.template = this.info.template;
        this.transaction = this.tokenServiceService.getAndDecodeToken();

        this.setCurrentCountry();
        this.isBamPaymethod = this.isBAM(this.info.originCode);
        this.isBiAgencyPaymethod = this.isBiAgency(this.info.code);
        this.isBiAgentPaymethod = this.isBiAgent(this.info.code);
        this.isSuper24PayMethod = this.isSuper24(this.info.originCode);
        this.isBancoNacionalDepositPayMethod = this.info.originCode === BANK_IDS.BNCR_DEPOSIT;
        this.viewReference = this.transaction.ORDER_CURRENCY === CURRENCIES.CRC;

        if (this.info.template === 'deposit') {
            this.user = 'Depósito Bancario';
            this.showSpecial = this.info.category === '5' ? true : false;
        } else if (this.info.template === 'cash') {
            this.user = 'Efectivo';
        }

        if (this.showSpecial) {
            this.consultDepositAttemps();
        }

      this.featureFlagService.getFeatureFlagValue(FLAGS_NAME.TRANSFER_AND_DEPOSITS_AUTOCOMPLETE_FF, FLAGS_NAME.TRANSFER_AND_DEPOSITS_AUTOCOMPLETE_FF).subscribe((response: boolean) => {
        this.transferAndDepositsAutoCompleteFF = response;

        const additionalInfo = this.tokenServiceService.exitsAdditionalInformation(this.transaction);

        if (additionalInfo && this.transferAndDepositsAutoCompleteFF) return this.disabledItems(additionalInfo);
      });
    }

     /**
     *
     * @description {isControlReadOnly} function to check if form fields are read-only
     * @param controlName
     * @returns
     */
    isControlReadOnly(controlName: string): boolean {
      const readOnlyControl = this.objectControlData.find((m) => m.formControl === controlName);

      return readOnlyControl ? readOnlyControl.readOnly : false;
    }

    /**
    *
    * @description {disabledItems} Function to disabled items to checkout form
    */
    disabledItems(additionalInfo) {
        try {
            this.isEditableInfo = this.tokenServiceService.isEditableInfo(additionalInfo);

            this.patchValAdditionalInfoService.patchValAdditionalInfo(
                this.isEditableInfo,
                additionalInfo,
                this.emailForm,
                AUTOCOMPLETE_METHOD_PAY_TYPES.DEPOSITS_AND_TRANSFERS,
                this.objectControlData,
            );
        } catch (_) {
            this.alertService.showAlert(ALERT_ERRORS.GET_TOKEN_DATA_ERROR);
        }
    }

    notCRC() {
        return this.currentCountry != AVAILABLE_TRANSLATIONS.CRC;
    }

    getActualRC() {
        let textSucur = 'deposit-sucur-generic';
        switch (this.info.code) {
            case 270:
            case 271:
                textSucur = 'deposit-sucur-bcr';
                break;
            case 280:
            case 281:
                textSucur = 'deposit-sucur-bnacional';
                break;
        }
        return textSucur;
    }

    setCurrentCountry() {
        const currency = this.transaction.ORDER_CURRENCY;
        switch (currency) {
            case CURRENCIES.COP:
                this.currentCountry = AVAILABLE_TRANSLATIONS.COL;
                break;
            case CURRENCIES.PEN:
                this.currentCountry = AVAILABLE_TRANSLATIONS.PER;
                break;
            case CURRENCIES.USD:
                this.currentCountry = AVAILABLE_TRANSLATIONS.ECU;
                break;
            case CURRENCIES.CRC:
                this.currentCountry = AVAILABLE_TRANSLATIONS.CRC;
                break;
            case CURRENCIES.GTQ:
                this.currentCountry = AVAILABLE_TRANSLATIONS.GTM;
                break;
            default:
                this.currentCountry = AVAILABLE_TRANSLATIONS.COL;
                break;
        }
    }

    print() {
        this.printServicesService.print(this.elem.nativeElement.innerHTML);
    }

    changeMethod() {
        this.CASH.emit();
    }

    onActivate() {
        window.scroll(0, 0);
    }

    consultDepositAttemps() {
        this.loading = true;
        this.depositManager.consultOrder(this.transaction.ORDER_CODE.toString()).subscribe((res: any) => {
            this.attemps = res.attemps;
            this.loading = false;
        });
    }

    get email() {
        return this.emailForm.get('email').value;
    }
    /**
     * @description {sendEmail} Function to send transaction email with rate limit
     */
    sendEmail() {
        this.loading = true;
        if (this.emailForm.valid) {
            this.depositManager.sendEmailWithLimit(this.transaction.ORDER_CODE.toString(), this.email).subscribe({
                next: (response) => {
                    if (response) {
                        this.alertService.showPopup(ALERT_MESSAGES.EMAIL_SENT, ALERT_MESSAGES.EMAIL_SENT_MESSAGE, 'success', ALERT_BUTTONS_MESSAGES.THANKS);
                        this.loading = false;
                        return;
                    }
                    this.alertService.showAlertProblem();
                },
                error: () => {
                    this.loading = false;
                    this.alertService.showPopup(ALERT_MESSAGES.EMAIL_NOT_SENT, ALERT_MESSAGES.EMAIL_NOT_SENT_RATE_LIMIT, 'error', ALERT_BUTTONS_MESSAGES.THANKS);
                },
            });
        }
    }

    /**
     *
     * @returns this.currentCountry
     */
    isGuatemala() {
        return this.currentCountry === AVAILABLE_TRANSLATIONS.GTM;
    }

    /**
     * @description returns if the commercial code belongs to those of Guatemala BAM paymethods
     */
    isBAM(code: number) {
        return code === BANK_GU_IDS.BAM_CASH || code === BANK_GU_IDS.BAM_DEPOSIT || code === BANK_GU_IDS.BAM_TRANSFER;
    }

    /**
     * @description returns if the commercial code belongs to those of Guatemala BI paymethods
     */
    isBiAgency(code: number) {
        return code.toString() === BANK_GU_IDS.BI_DEPOSIT.toString();
    }

    /**
     * @description returns if the commercial code belongs to those of Guatemala BI paymethods
     */
    isBiAgent(code: number) {
        return code.toString() === BANK_GU_IDS.BI_DEPOSIT_B.toString();
    }

    /**
     * @description returns if the commercial code belongs to those of Guatemala Super24 paymethods
     */
    isSuper24(code: number) {
        return code === BANK_GU_IDS.SUPER24_DEPOSIT;
    }

    /**
     *
     * @description {formPrivacyUpdate} Function that obtains the event of the validation of the child component
     * @param valid
     */
    formPrivacyUpdate(valid: boolean) {
        this.formPrivacyValid = valid;
        this.enableButton();
    }

    /**
     *
     * @description {enableButton} Function that validates and emit the event of the validation of the child component
     * @param valid
     */
    enableButton() {
        this.buttonEnabled = this.emailForm.valid && this.formPrivacyValid;
        this.buttonStateChange.emit(this.buttonEnabled);
    }
}
